import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { SCREEN_ID_UTILITY_PROFIT_PARTNER_REDIRECT } from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import branch from 'client/core/branch';
import UtilityPartnerActions from 'client/actions/UtilityPartner';
import { hasRoleAnonymous } from 'common/utility/userRoles';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_PROFIT_PARTNER_REDIRECT)
@withScrollToTop
@branch({
  currentPartner: ['partners', 'currentPartner'],
  utilityUser: ['utilityUser'],
  currentUtilityPartner: ['utilityPartners', 'currentPartner'],
})
class UtilityProfitRedirectPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Profit | Overview',
  });

  static fetchData(match, inject) {
    const utilityUser = inject.state.get(['utilityUser']);

    if (hasRoleAnonymous(utilityUser.roles)) {
      return;
    }

    const currentUtilityPartner = inject.state.get(['utilityPartners', 'currentPartner']);

    if (!currentUtilityPartner && utilityUser.utilityPartnerId) {
      return UtilityPartnerActions.loadCurrentUtilityPartner(inject, {
        id: utilityUser.utilityPartnerId,
      });
    }
  }

  render() {
    const { utilityUser, currentPartner: sunroomPartner, currentUtilityPartner } = this.props;

    if (sunroomPartner) {
      return <Redirect to={`/partner/${sunroomPartner.slug}/utility-profit`} />;
    }

    if (hasRoleAnonymous(utilityUser.roles)) {
      return <Redirect to="/utility-profit/login" />;
    }

    if (currentUtilityPartner) {
      return <Redirect to={`/utility-profit/${currentUtilityPartner.slug}`} />;
    }

    return <Redirect to="/logout" />;
  }
}

UtilityProfitRedirectPage.displayName = 'UtilityProfitRedirectPage';

export default UtilityProfitRedirectPage;
